import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7f2fa934"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 1,
  class: "classification"
};
const _hoisted_2 = {
  class: "left_tab"
};
const _hoisted_3 = ["onClick"];

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "line"
}, null, -1));

const _hoisted_5 = {
  class: "right_cont"
};
const _hoisted_6 = {
  class: "swiper_cont"
};
const _hoisted_7 = {
  class: "top"
};
const _hoisted_8 = {
  class: "title"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "热门创作者", -1));

const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "img"
};
const _hoisted_12 = {
  class: "text_ellipsis"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "label_title"
}, "全部标签", -1));

const _hoisted_14 = {
  class: "label_list"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  key: 0,
  class: "label_item label_item_null"
};
const _hoisted_17 = {
  class: "search_details_page"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_loading = _resolveComponent("loading");

  const _component_my_image = _resolveComponent("my-image");

  const _component_swiper_slide = _resolveComponent("swiper-slide");

  const _component_swiper = _resolveComponent("swiper");

  const _component_van_swipe_item = _resolveComponent("van-swipe-item");

  const _component_van_swipe = _resolveComponent("van-swipe");

  const _component_search_popup = _resolveComponent("search-popup");

  const _component_van_popup = _resolveComponent("van-popup");

  return $setup.shoeLoading ? (_openBlock(), _createBlock(_component_loading, {
    key: 0
  })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(["tab_item", index === $setup.activeIndex ? 'active' : '']),
      onClick: $event => $setup.tabItemClick(item, index)
    }, [_hoisted_4, _createTextVNode(" " + _toDisplayString(item.name), 1)], 10, _hoisted_3);
  }), 128))]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_swipe, {
    ref: "swipe",
    loop: false,
    vertical: "",
    touchable: false
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuList, (i, d) => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        key: d
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("p", _hoisted_8, [_hoisted_9, _createElementVNode("span", {
          class: "look_all",
          onClick: _cache[0] || (_cache[0] = (...args) => $setup.menuAll && $setup.menuAll(...args))
        }, "查看全部")]), _createElementVNode("ul", null, [(_openBlock(), _createBlock(_component_swiper, {
          "slides-per-view": 4,
          "space-between": 15,
          key: d,
          autoplay: false,
          touchStartForcePreventDefault: true,
          touchMoveStopPropagation: true,
          scrollbar: {
            draggable: true,
            stopPropagation: true,
            touchMoveStopPropagation: true,
            touchStartForcePreventDefault: true
          },
          class: "teacher_ul",
          id: "teacher_ul"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.hotAuthorList, a => {
            return _openBlock(), _createBlock(_component_swiper_slide, {
              class: "teacher_li",
              key: a.id
            }, {
              default: _withCtx(() => [_createElementVNode("li", {
                onClick: $event => $setup.toAutorDetails(a)
              }, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_my_image, {
                url: a.top || '123.png'
              }, null, 8, ["url"])]), _createElementVNode("p", _hoisted_12, _toDisplayString(a.nickname), 1)], 8, _hoisted_10)]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 2
        }, 1024))])]), _hoisted_13, _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i.label, (b, c) => {
          return _openBlock(), _createElementBlock("div", {
            key: c,
            onClick: $event => $setup.labelSearch(b),
            class: "label_item"
          }, _toDisplayString(b.name), 9, _hoisted_15);
        }), 128)), 50 % 3 === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_16)) : _createCommentVNode("", true)])])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 512)]), _createVNode(_component_van_popup, {
    show: $setup.showDetailsPopul,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => $setup.showDetailsPopul = $event),
    class: "popup_coentent",
    teleport: "#app",
    overlay: false,
    position: "right"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [$setup.popupType === 1 ? (_openBlock(), _createBlock(_component_search_popup, {
      key: 0,
      searchText: $setup.searchText,
      menu_id: $setup.menu_id,
      label_id: $setup.label_id,
      onClose: $setup.close
    }, null, 8, ["searchText", "menu_id", "label_id", "onClose"])) : _createCommentVNode("", true)])]),
    _: 1
  }, 8, ["show"])]));
}